import { Portal, Progress } from '@antoree/ant-ui';
import { MainLayout, PrivateRoute } from 'components';
import { PUBLIC_URL } from 'configs/env.conf';

import { isAuthenticated } from 'helpers';
import { lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';

import { NotificationToast } from 'components/Notification';
import GlobalSocketListener from 'components/GlobalSocketListener';

const fallbackComponent = (
  <div className="absolute z-10">
    <Portal>
      <Progress size="xs" color="#32C081" position="fixed" />
    </Portal>
  </div>
);

// const EnterTest = lazy(() => import('containers/EnterTest'));
const SignIn = lazy(() => import('containers/SignIn'));
const Courses = lazy(() => import('containers/Courses'));
const Sessions = lazy(() => import('containers/Sessions'));
const Schedule = lazy(() => import('containers/Schedule'));
const Chat = lazy(() => import('containers/Chat'));
const Salary = lazy(() => import('containers/Salary'));
const MyInfo = lazy(() => import('containers/MyInfo'));
const Payment = lazy(() => import('containers/Info/components/Payment'));
const Booking = lazy(() => import('containers/Booking'));
const Assessment = lazy(() => import('containers/AssessmentList/components'));
const AssessmentList = lazy(() => import('containers/AssessmentList'));
const Homework = lazy(() => import('containers/Homework'));

const AbsentDetail = lazy(() => import('containers/AbsentDetail'));
function AppRouter() {
  return (
    <Suspense fallback={fallbackComponent}>
      <Router basename={PUBLIC_URL}>
        <NotificationToast />
        <GlobalSocketListener />
        <QueryParamProvider ReactRouterRoute={Route}>
          <Switch>
            {/* <Route path="/enter-test" exact component={EnterTest} /> */}
            <Route path="/sign-in" exact component={SignIn} />
            <Route path="/forgot-password" exact component={SignIn} />
            <PrivateRoute
              redirectPath="/sign-in"
              path="/(home|courses|schedule|salary|payment|claim-request|chat|assessment|assessments|homework)"
            >
              <MainLayout>
                <Suspense fallback={fallbackComponent}>
                  <Switch>
                    <Route
                      path="/home"
                      exact
                      render={() => <Redirect to="/claim-request" />}
                    />
                    <Route path="/courses" exact component={Courses} />
                    <Route path="/salary" exact component={Salary} />
                    <Route path="/payment" exact component={Payment} />
                    <Route
                      path="/courses/:id/sessions"
                      exact
                      component={Sessions}
                    />
                    <Route
                      path="/schedule/teaching-schedule"
                      exact
                      component={Schedule}
                    />
                    <Route
                      path="/schedule/available-time"
                      exact
                      component={Schedule}
                    />
                    <Route path="/chat" exact component={Chat} />
                    <Route
                      path="/salary/salary-rate"
                      exact
                      component={Salary}
                    />
                    <Route
                      path="/salary/salary-term"
                      exact
                      component={Salary}
                    />
                    <Route
                      path="/claim-request/:id"
                      exact
                      component={Booking}
                    />
                    <Route path="/claim-request" exact component={Booking} />
                    <Route
                      path="/assessment"
                      exact
                      render={() => <Redirect to="/assessments" />}
                    />
                    <Route
                      path="/assessment/:assessmentId"
                      exact
                      component={Assessment}
                    />
                    <Route
                      path="/assessments"
                      exact
                      component={AssessmentList}
                    />
                    <Route
                      path="/assessments/:assessmentId"
                      exact
                      component={Assessment}
                    />
                    <Route
                      path="/homework/:homeworkId"
                      exact
                      component={Homework}
                    />
                    <Route
                      path="/absent-detail/:id"
                      exact
                      component={AbsentDetail}
                    />
                    {/* <Route path="/info" exact component={MyInfo} /> */}
                  </Switch>
                </Suspense>
              </MainLayout>
            </PrivateRoute>
            <Route
              path="*"
              render={() => {
                if (isAuthenticated()) {
                  return <Redirect to="/claim-request" />;
                }
                return <Redirect to="/sign-in" />;
              }}
            />
          </Switch>
        </QueryParamProvider>
      </Router>
    </Suspense>
  );
}

export default AppRouter;
